import { render, staticRenderFns } from "./CurriculumCategory.vue?vue&type=template&id=29af2d1a"
import script from "./CurriculumCategory.vue?vue&type=script&lang=js"
export * from "./CurriculumCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports